import React, {useState} from "react";
import {Divider, Typography, withStyles} from "@material-ui/core";
import BoldTypography from "components/BoldTypography";
import StageApprovers from "./StageApprovers";
import Tr from "translations/Translations";
import Button from "components/Button";
import Form from "components/Form";
import {selectApproversValidationShema} from "./constants/validationSchema";
import GridBlock from "components/GridBlock";
import Confirm from "components/popup/confirm/Confirm";
import {canMasterReset} from "./lib/ApprovalAccessUtils";
import * as PropTypes from "prop-types";
import ShowErrorOnFailedSubmit from "components/ShowErrorOnFailedSubmit";
import reduxStore from "redux/store";

const style = theme => ({
    root: {
        border: `solid 2px ${theme.palette.primary.main}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2),
        marginTop: theme.spacing()
    },
    selectApprovers: {
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    approval: {
        marginLeft: theme.spacing(2)
    },
    buttons: {
        marginTop: theme.spacing()
    },
    mr: {
        marginRight: theme.spacing(1)
    }
});

function SelectApprovers(
    {
        approval,
        sendToApproval,
        resetApproval,
        stopApproval,
        classes,
        working
    }) {

    const [checkError, setCheckError] = useState(false);
    const [masterResetOpen, setMasterResetOpen] = useState(false);
    const [masterStopOpen, setMasterStopOpen] = useState(false);
    const stageForSelectApprovers = approval.stages.filter(s => s.status === 1 || (approval.selectApproversAtStart === true && s.status === 0));

    const initialValues = () => {
        const o = {};
        o.identity = approval.identity;
        o.stages = approval.stages.map(stage => {
            const s = {};
            s.identity = stage.identity;
            s.approvers = stage.approvers.map(a => ({
                ...a,
                selected: false
            }));
            s.assigneeComment = null;
            return s;
        });
        return o;
    }

    return (
        <>
            <Form
                onSubmit={sendToApproval}
                initialValues={initialValues()}
                id={'Approval'}
                validationSchema={selectApproversValidationShema(approval)}
                afterSubmitFunc={() => {
                    setCheckError(true);
                }}
            >
                {(formikProps) => {
                    return (
                    <>
                        <ShowErrorOnFailedSubmit
                            formikProps={formikProps}
                            checkError={checkError}
                            setCheckError={setCheckError}
                            errorMsg={Tr('selectApproversMinCountError')}
                        />
                        <BoldTypography className={classes.approval}>{approval.name}</BoldTypography>
                        <div className={classes.root}>
                            <Typography color="error">{Tr('selectApproversInfo')}</Typography>
                            {stageForSelectApprovers.map((stage, index) => (
                                <div key={`sid${stage.identity}`}>
                                    <StageApprovers id={`stages.${index}`} stage={stage} opened={stageForSelectApprovers.length === 1} formikProps={formikProps} />
                                    <Divider className={classes.divider}/>
                                </div>
                                ))
                            }
                        </div>
                        <GridBlock direction='row-reverse' className={classes.buttons}>
                            {canMasterReset(approval, stageForSelectApprovers[0]) && <Button
                                disabled={!approval.formVisible || working}
                                onClick={() => setMasterResetOpen(true)}
                                className={classes.mr}
                                variant={'outlined'}
                            >
                                {Tr('approverMasterReset')}
                            </Button>}
                            <Button
                                disabled={!approval.canSelectApprovers || working}
                                onClick={() => setMasterStopOpen(true)}
                                className={classes.mr}
                                variant={'outlined'}
                            >
                                {Tr('approverMasterStop')}
                            </Button>
                            <Button
                                disabled={!approval.canSelectApprovers || working}
                                onClick={() => {
                                    const { form } = reduxStore.getState();
                                    form['Approval']();
                                }}
                                className={classes.mr}
                            >
                                {Tr('sendToApproval')}
                            </Button>
                        </GridBlock>
                        <Confirm
                            open={masterResetOpen}
                            onConfirm={() => {
                                resetApproval();
                                setMasterResetOpen(false);
                            }}
                            onCancel={() => setMasterResetOpen(false)}
                            confirmText="approverMasterReset_confirm"
                        />
                        <Confirm
                            open={masterStopOpen}
                            onConfirm={() => {
                                stopApproval();
                                setMasterStopOpen(false);
                            }}
                            onCancel={() => setMasterStopOpen(false)}
                            confirmText="approverMasterStop_confirm"
                        />
                    </>
                )}}
            </Form>
        </>);
}

SelectApprovers.propTypes = {
    approval: PropTypes.object,
    sendToApproval: PropTypes.func,
    resetApproval: PropTypes.func,
    stopApproval: PropTypes.func,
    classes: PropTypes.any,
    working: PropTypes.bool
}

export default withStyles(style)(SelectApprovers);